import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { API_URL } from '../../Constants';

let apiUrl = API_URL;


function CreateCommerceView() {
    const [status, setStatus] = useState("");

    const handleCreateCommerceRequest = () => {
        let name = document.getElementById("businessName").value;
        let documentType = document.getElementById("documentType").value;
        let documentNumber = document.getElementById("documentNumber").value;
        let cellphone = document.getElementById("cellphone").value;
        let phone = document.getElementById("phone").value;
        let address = document.getElementById("address").value;

        console.log(name);
        console.log(phone);
        console.log(documentType);
        console.log(documentNumber);
        console.log(cellphone);
        console.log(address);
        if (name === "" || documentType === "" || documentNumber === "" || cellphone === "" || address === "") {
            alert("Revisa los campos obligatorios")
        } else {
            let commerce = { name: name, cellphone: cellphone, documentType: documentType, documentNumber: documentNumber, phone: phone, address: address }
            createCommerce(commerce)
        }
    }

    const createCommerce = (commerce) => {
        fetch(apiUrl + '/v1/commerces', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(commerce),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    console.log(res.uuid)
                    setStatus("created")
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }

    const handleBackToHome = () => {
        window.location = '/pending';
    }

    return (
        <React.Fragment>
            <CssBaseline />

            <Container maxWidth="md">
                <br />
                {status == "created" ?
                    <h1>creado</h1>
                    :
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <form>
                            <TextField
                                required
                                id="businessName"
                                label="Nombre"
                                defaultValue=""
                            />
                            <br />
                            <TextField
                                required
                                id="documentType"
                                label="Tipo de documento"
                                defaultValue=""
                            />
                            <br />
                            <TextField
                                required
                                id="documentNumber"
                                label="Numero de documento"
                                defaultValue=""
                            />
                            <br />
                            <TextField
                                required
                                id="cellphone"
                                label="Celular"
                                defaultValue=""
                            />
                            <br />
                            <TextField
                                id="phone"
                                label="Telefono"
                                defaultValue=""
                            />
                            <br />
                            <TextField
                                required
                                id="address"
                                label="Dirección"
                                defaultValue=""
                            />
                            <br />
                            <br />
                            <Stack direction="row" spacing={2}>
                                <Button variant="contained" endIcon={<SendIcon />} className='button' onClick={handleCreateCommerceRequest}>
                                    Crear comercio
                                </Button>
                            </Stack>
                        </form>
                    </Box>}
                    <br />
                <Stack direction="row" spacing={2}>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={handleBackToHome}>
                        Volver
                    </Button>
                </Stack>

            </Container>
        </React.Fragment>

    );
}

export default CreateCommerceView;